import type { MetaTrackEvent } from '@repo/single-spa';

type Fbq = (...args: unknown[]) => void;

// TT-289: one standard event through the Pixel; eventID pairs it with the server copy (TT-290)
export function trackMetaEvent(
  { event, eventId }: MetaTrackEvent,
  fbq: Fbq | undefined = (window as Window & { fbq?: Fbq }).fbq
): void {
  if (typeof fbq !== 'function') {
    return;
  }
  if (eventId) {
    fbq('track', event, {}, { eventID: eventId });
  } else {
    fbq('track', event, {});
  }
}
